/**
 * Checkout slug: used to resume order flow after guest login (e.g. 'order').
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

export const CHECKOUT_SLUG_KEY = 'checkoutSlug';

export async function getCheckoutSlug(): Promise<string | null> {
  try {
    const raw = await AsyncStorage.getItem(CHECKOUT_SLUG_KEY);
    return raw?.trim() || null;
  } catch {
    return null;
  }
}

export async function setCheckoutSlug(slug: string): Promise<void> {
  try {
    await AsyncStorage.setItem(CHECKOUT_SLUG_KEY, slug);
  } catch {
    // ignore
  }
}

export async function clearCheckoutSlug(): Promise<void> {
  try {
    await AsyncStorage.removeItem(CHECKOUT_SLUG_KEY);
  } catch {
    // ignore
  }
}
